<div
  class="container"
  [class.selected]="answer().isSelected">
  <div class="select">
    <coin-v2-radio-button
      [name]="answer().title"
      [ngModel]="answer().isSelected"
      [disabled]="surveyComponent.isDisabled()"
      (ngModelChange)="surveyQuestionComponent.onAnswerToggle(!answer().isSelected, answer())" />
  </div>
  <div class="info">
    <div class="text">
      <h4>{{ answer()?.title | translate }}</h4>
      @if (answer()?.description) {
        <p>{{ answer()?.description | translate }}</p>
      }
    </div>
  </div>
</div>
